module.exports = __webpack_public_path__ + "static/img/12.7c7ef1e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/9/eng/12.png
// module id = DMsI
// module chunks = 0